'use client';

import { ChevronLeft } from 'lucide-react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import logoWhite from '@/app/assets/imgs/logo-white.png';
import { cn } from '@/app/utils';
import { Link, usePathname } from '@/i18n/routing';

const nav = [{ href: '/artist-program/activities', key: 'activities' }] as const;

export function ArtistProgramHeader() {
  const t = useTranslations('artistProgram.header');
  const pathname = usePathname();
  const detail = pathname.includes('/artist-program/activities/');
  return (
    <header className="absolute inset-x-0 top-0 z-30">
      <div className="mx-auto flex h-20 max-w-[1440px] items-center justify-between px-12 sm:h-16 sm:px-5">
        {detail ? (
          <Link
            href="/artist-program/activities"
            className="inline-flex h-11 items-center gap-2 rounded-full bg-white/28 px-6 font-semibold text-[15px] text-white backdrop-blur-xl"
          >
            <ChevronLeft className="size-5" />
            {t('back')}
          </Link>
        ) : (
          <Link href="/" className="relative h-8 w-[82px]" aria-label="Vidu home">
            <Image src={logoWhite} alt="Vidu" fill sizes="82px" className="object-contain" priority />
          </Link>
        )}
        {!detail && (
          <nav className="flex items-center gap-5 sm:gap-2">
            {nav.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className={cn(
                  'inline-flex h-11 min-w-[146px] items-center justify-center rounded-full px-6 font-semibold text-[15px] text-white sm:min-w-0 sm:px-4',
                  pathname.includes(item.href) ? 'bg-[#305AE0]' : 'bg-white/20 backdrop-blur-xl',
                )}
              >
                {t(item.key)}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}
